import io from 'socket.io-client';
import feathers, { socketio, authentication } from '@feathersjs/client';
import { rx } from 'feathers-reactive';

import castAmount from './app/hooks/cast-amount';
import config from './config';

export function create (url) {
  const options = { transports: ['websocket'], timeout: 20000 };
  const socket = io(url, options);

  const app = feathers()
    .configure(socketio(socket, { timeout: 60000 }))
    .configure(rx({ idField: 'id' }))
    .configure(authentication({ storage: localStorage }));

  app.socket = socket;

  process.env.NODE_ENV === 'development' && app.hooks({
    before (context) {
      console.log(`FEATHERS: ${context.path}:${context.method}:${JSON.stringify(context.params.query)} `);
    }
  });

  app.service('charges').hooks({
    after: { all: [castAmount()] }
  });

  return app;
}

export default create(config.apiUrl);
